// Publishes verifier identity to cookies on .mybiocalculus.com so sibling
// subdomains (e.g. reportweb4.mybiocalculus.com) can read who is logged in
// and attribute their activity time to the same session.

const COOKIE_DOMAIN = ".mybiocalculus.com";
const COOKIE_KEYS = [
  "verifierid",
  "verifiername",
  "verifiertype",
  "loginedDateTime",
  "loggedInTime",
];
const HEARTBEAT_KEY = "lastActivityAt";
const BREAK_KEYS = ["breakTime", "isOnBreak", "breakStartTime"];

const setCookie = (name, value, days = 1) => {
  if (value === null || value === undefined) return;
  const expires = new Date(Date.now() + days * 864e5).toUTCString();
  const secure = window.location.protocol === "https:" ? "; secure" : "";
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; expires=${expires}; path=/; domain=${COOKIE_DOMAIN}; samesite=Lax${secure}`;
};

const deleteCookie = (name) => {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=${COOKIE_DOMAIN}`;
};

export const publishVerifierCookies = () => {
  COOKIE_KEYS.forEach((k) => setCookie(k, localStorage.getItem(k)));
};

export const clearVerifierCookies = () => {
  COOKIE_KEYS.forEach(deleteCookie);
  deleteCookie(HEARTBEAT_KEY);
  BREAK_KEYS.forEach(deleteCookie);
};

const readCookie = (name) => {
  const m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]+)"));
  return m ? decodeURIComponent(m[1]) : null;
};

export const writeBreakState = ({ breakTime, isOnBreak, breakStartTime }) => {
  if (breakTime !== undefined) setCookie("breakTime", String(breakTime));
  if (isOnBreak !== undefined) setCookie("isOnBreak", isOnBreak ? "true" : "false");
  if (breakStartTime !== undefined && breakStartTime !== null) {
    setCookie("breakStartTime", String(breakStartTime));
  } else if (breakStartTime === null) {
    deleteCookie("breakStartTime");
  }
};

export const readBreakState = () => {
  const bt = parseFloat(readCookie("breakTime"));
  const bs = readCookie("breakStartTime");
  return {
    breakTime: Number.isFinite(bt) ? bt : 0,
    isOnBreak: readCookie("isOnBreak") === "true",
    breakStartTime: bs ? parseInt(bs, 10) : null,
  };
};

let _lastHeartbeatWriteAt = 0;
export const writeHeartbeat = () => {
  const now = Date.now();
  if (now - _lastHeartbeatWriteAt < 5000) return;
  _lastHeartbeatWriteAt = now;
  setCookie(HEARTBEAT_KEY, String(now));
};

export const readHeartbeat = () => {
  const m = document.cookie.match(
    new RegExp("(?:^|; )" + HEARTBEAT_KEY + "=([^;]+)")
  );
  return m ? parseInt(decodeURIComponent(m[1]), 10) : 0;
};
